export default __webpack_public_path__ + "static/pexels-oleg-magni-2058128-afd2b6cb50e66e641ec0dea372a64dc9.jpg";